import React from "react";
import "./Privacidade.css";

export default function PoliticaPrivacidade() {
  return (
    <div className="politica-container">
      <h1>Política de Privacidade</h1>
      <p><strong>Última atualização:</strong> 6 de abril de 2025</p>

      <h2>Coleta de Dados</h2>
      <p>
        Durante sua visita, coletamos informações <strong>anônimas</strong> por meio do serviço <strong>Google Analytics</strong>, incluindo:
      </p>
      <ul>
        <li>Páginas visitadas</li>
        <li>Tempo de navegação</li>
        <li>Dispositivo e navegador utilizados</li>
        <li>Localização aproximada (país e cidade)</li>
      </ul>
      <p>
        Esses dados são utilizados exclusivamente para fins <strong>estatísticos e de melhoria da experiência</strong> no site. Nenhum dado pessoal identificável é coletado.
      </p>

      <h2>Uso de Cookies</h2>
      <p>
        Utilizamos <strong>cookies</strong> para armazenar informações de navegação e possibilitar a análise de tráfego com o Google Analytics.
        Você pode optar por <strong>aceitar ou recusar</strong> os cookies através do banner exibido ao acessar o site.
      </p>
      <p>
        Também é possível desabilitar cookies diretamente nas configurações do seu navegador.
      </p>

      <h2>Segurança</h2>
      <p>
        Não coletamos dados pessoais diretamente neste site. Portanto, não armazenamos nenhuma informação sensível ou que possa identificar você individualmente.
      </p>

      <h2>Contato</h2>
      <p>
        Se tiver dúvidas sobre esta política, entre em contato pelo e-mail: <a href="mailto:dr.lucianogazzoni@gmail.com">dr.lucianogazzoni@gmail.com</a>
      </p>
    </div>
  );
}